import { render, staticRenderFns } from "./OneTwoOneMarketing.vue?vue&type=template&id=f6cd5676&scoped=true"
import script from "./OneTwoOneMarketing.vue?vue&type=script&lang=js"
export * from "./OneTwoOneMarketing.vue?vue&type=script&lang=js"
import style0 from "./OneTwoOneMarketing.vue?vue&type=style&index=0&id=f6cd5676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cd5676",
  null
  
)

export default component.exports